import PricePlan from "./PricePlan";

export default PricePlan